// extracted by mini-css-extract-plugin
module.exports = {"fullAdWrapper":"BrandPageUI_fullAdWrapper__sNd_Y","howItWorksContainer":"BrandPageUI_howItWorksContainer__xVhh4","noPerkSection":"BrandPageUI_noPerkSection__KKTNL"};